import React, { Fragment, useEffect, useState } from "react";
import Constant from "../../../utils/constant";
import {
  getStandard,
  addStandard,
  updateStandard,
  uploadStandardIcon,
} from "../../../api/standard.service";
import {
  IStandard,
  IStandardVideoData,
} from "../../../model/interface/standard";
import { postAcademicsActivity } from "../../../api/academicsActivity.service";
import { IAcademicsActivity } from "../../../model/interface/academicsActivty";
import { DropdownItem } from "../../../model/interface/keyValuePair";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { useLocation, Link, useNavigate, useParams } from "react-router";
import Select from "react-select";
import LinkedStandard from "./linkedStandard";
import AssociatedQuestion from "./associatedQuestionTab";
import Worksheet from "./worksheet";
import Videos from "./standardVideos";
import { useForm } from "react-hook-form";
import Loader from "../../shared/loader/loader";
import AddStandardGroup from "../../shared/common/addStandardGroup";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { toast } from "react-toastify";
import { Slide } from "./Slide";

function ManageStandard(props: any) {
  const defaultDropdownValues: DropdownItem = {
    label: "",
    value: "0",
  };
  const defaultStandardVideoData: IStandardVideoData = {
    contentAreaId: 0,
    contentAreaName: "",
    subjectId: 0,
    subjectName: "",
    domainId: 0,
    domainName: "",
    standardId: 0,
    standardName: "",
  };
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();

  const [idToEdit, setIdToEdit] = useState<number | null>(() => {
    if (!id) return null;
    const cleanId = id.replace(/[^.\d]/g, "");
    const parsedId = parseInt(cleanId, 10);
    return isNaN(parsedId) ? null : parsedId;
  });
  const [contentAreas, setContentAreas] = useState<DropdownItem[]>([]);
  const [subjects, setSubjects] = useState<DropdownItem[]>([]);
  const [domains, setDomains] = useState<DropdownItem[]>([]);
  const [standardData, setStandardData] = useState<IStandard>();
  const [standardVideoData, setStandardVideoData] =
    useState<IStandardVideoData>(defaultStandardVideoData);
  const [selectedContent, setSelectedContent] = useState<DropdownItem>(
    defaultDropdownValues
  );
  const [selectedSubject, setSelectedSubject] = useState<DropdownItem>(
    defaultDropdownValues
  );
  const [selectedDomain, setSelectedDomain] = useState<DropdownItem>(
    defaultDropdownValues
  );
  const [loadOrder, setLoadOrder] = useState<number>(
    standardData ? standardData.loadOrder : 0
  );
  const [description, setDescription] = useState<string>(
    standardData ? standardData.description : ""
  );
  const [notes, setNotes] = useState<string>(
    standardData ? standardData.notes ?? "" : ""
  );
  let successMessage: string;
  const [loading, setLoading] = useState<boolean>(false);
  const [lang, setLang] = useState<number>(1);
  const [standardIcon, setStandardIcon] = useState<string>("");
  const [isHideFromStudentPractice, setIsHideFromStudentPractice] =
    useState<boolean>(false);
  const [isTestedStandard, setIsTestedStandard] = useState<boolean>(false);

  const [standardGroupInfo, setStandardGroupInfo] = useState<any>({
    subjectId: 0,
    standardId: 0,
    domainId: 0,
    existingStandardGroups: [],
  });
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [reloadIcon, setReloadIcon] = useState<boolean>(true);

  const [standardName, setStandardName] = useState("");
  const [code, setCode] = useState("");
  const [isValid, setIsValid] = useState(true);

  const location = useLocation();
  const parameters = location.state as any;

  type tabName =
    | "LinkedStandard"
    | "AssociatedQuestions"
    | "Worksheets"
    | "Videos"
    | "Slides";
  const [activeTab, setActiveTab] = useState<tabName>("LinkedStandard");
  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  function handleLoadOrderChange(e: any) {
    setLoadOrder(parseInt(e.target.value));
  }

  function handleDesciptionChange(e: any) {
    setDescription(e.target.value);
  }

  function handleNotesChange(e: any) {
    setNotes(e.target.value);
  }

  function validate() {
    let isValid = true;
    if (standardName === "") {
      isValid = false;
    } else if (code === "") {
      isValid = false;
    }
    setIsValid(isValid);
    return isValid;
  }

  async function submitHandler(data: any) {
    if (!validate()) {
      return;
    }

    setLoading(true);
    const standard: IStandard = {
      name: standardName,
      contentAreaId: selectedContent ? selectedContent.value : "",
      subjectId: selectedSubject ? selectedSubject.value : "",
      domainId: selectedDomain ? selectedDomain.value : "0",
      code: code,
      isActive: true,
      description: description,
      notes: notes,
      loadOrder: loadOrder,
      isApproved: data.isApproved ? data.isApproved : true,
      isHiddenFromStudentPractice: isHideFromStudentPractice
        ? isHideFromStudentPractice
        : false,
      isTestedStandard: isTestedStandard ? isTestedStandard : false,
      standardIcon: data.standardIcon,
    };

    if (data?.spanishName) {
      standard.spanishName = data.spanishName;
    }

    let standardId = 0;
    if (idToEdit && idToEdit > 0) {
      standard.standardId = idToEdit;
      standardId = idToEdit;
      await updateStandard(standard);
      const academicsActivity: IAcademicsActivity = {
        Name: "Standard",
        ActivityTypeId: Constant.ACADEMICSACTYVITYTYPE.EDIT,
        UpdatedByUserId: 1,
      };
      postAcademicsActivity(academicsActivity);

      successMessage = "Standard updated successfully";
    } else {
      const data = await addStandard(standard);
      successMessage = `Standard added successfully, ID- ${data.data}`;
      standardId = data.data;
    }

    if (standardIcon !== null && standardIcon !== undefined) {
      //upload icon
      setReloadIcon(false);
      const formData = new FormData();
      formData.append("standardId", standardId.toString());
      formData.append("standardFile", standardIcon);
      formData.append("name", standard.name);
      formData.append("standardIcon", standard.standardIcon ?? "");

      await uploadStandardIcon(formData).then((res) => {
        standard.standardIcon = res.data;
        setReloadIcon(true);
      });
    }
    setLoading(false);
    toast.success(successMessage);

    if (idToEdit && idToEdit > 0) {
      navigate(Constant.EDITSTANDARD.replace(":id", idToEdit.toString()));
    } else {
      if (parameters?.redirectBack) {
        navigate(-1);
      } else {
        navigate(Constant.STANDARDS);
      }
    }
  }

  function bindEditData(standard: IStandard) {
    setStandardName(standard.name);
    setCode(standard.code);

    setLoadOrder(standard.loadOrder);
    setDescription(standard.description);
    setNotes(standard.notes ?? "");
    setIsHideFromStudentPractice(standard.isHiddenFromStudentPractice!);
    setIsTestedStandard(standard.isTestedStandard!);
  }

  async function bindContentAreas(selectedItem?: DropdownItem) {
    setLoading(true);
    const service = await import("../../../api/contentArea.service");
    service.getContentArea().then((response) => {
      const result = response.data.data;
      const contentAreaData = result.map((item) => {
        return { label: item.name, value: item.contentAreaId };
      });
      setContentAreas(contentAreaData);
      if (selectedItem) {
        setSelectedContent(selectedItem);
      } else if (parameters?.autoFillData) {
        const selectedContentArea = contentAreaData.find((t) => {
          return t.value === parameters?.autoFillData.contentId;
        });
        setSelectedContent(selectedContentArea);
      }
      setLoading(false);
    });
  }

  async function bindSubjects(contentId: number, selectedItem?: DropdownItem) {
    setLoading(true);
    const service = await import("../../../api/subject.service");
    service.getSubjectAllByContent(contentId).then((response) => {
      const result = response.data;
      const subjectsData = result.map((item) => {
        return { label: item.subjectName, value: item.subjectId };
      });
      setSubjects(subjectsData);
      if (selectedItem) {
        setSelectedSubject(selectedItem);
      } else if (parameters?.autoFillData) {
        const selectedSubject = subjectsData.find((t) => {
          return t.value === parameters?.autoFillData.subjectId;
        });
        setSelectedSubject(selectedSubject);
      }
      setLoading(false);
    });
  }

  async function bindDomains(subjectId: number, selectedItem?: DropdownItem) {
    const service = await import("../../../api/domain.service");
    service.getAllDomainsBySubject(subjectId).then((response) => {
      setLoading(true);

      const result = response.data.data;
      const domainsData = result.map((item) => {
        return { label: item.name, value: item.domainId };
      });
      setDomains(domainsData);
      if (selectedItem) {
        setSelectedDomain(selectedItem);
      } else if (parameters?.autoFillData) {
        const selectedDomain = domainsData?.find((t) => {
          return t.value === parameters?.autoFillData?.domainId;
        });
        setSelectedDomain(selectedDomain);
      }

      setLoading(false);
    });
  }

  function handleContentAreaChange(selectedItem: any) {
    setSelectedContent(selectedItem);
    setSelectedSubject(defaultDropdownValues);
    setSelectedDomain(defaultDropdownValues);
    bindSubjects(selectedItem.value);
  }

  function handleSubjectChange(selectedItem: any) {
    setSelectedSubject(selectedItem);
    setSelectedDomain(defaultDropdownValues);
    bindDomains(selectedItem.value);
  }

  function handleDomainChange(e: any) {
    setSelectedDomain(e);
  }

  useEffect(() => {
    const standardIdToEdit = idToEdit;

    if (standardIdToEdit) {
      setLoading(true);
      setIdToEdit(standardIdToEdit);
      const standardDetails = getStandard(standardIdToEdit);
      Promise.all([standardDetails]).then(() => {
        standardDetails.then((response) => {
          setLoading(false);

          const standardData: any = response.data;
          setStandardData(standardData);
          const tempStandardVideoData: IStandardVideoData = {
            contentAreaId: standardData?.contentId,
            contentAreaName: standardData?.contentName,
            subjectId: standardData?.subjectId,
            subjectName: standardData?.subjectName,
            domainId: standardData?.domainId,
            domainName: standardData?.domainName,
            standardId: standardIdToEdit,
            standardName: standardData?.name,
          };

          setStandardVideoData(tempStandardVideoData);
          bindEditData(standardData);

          const selectedContent: any = standardData
            ? {
                label: standardData.contentName,
                value: standardData.contentId,
              }
            : undefined;

          const selectedSubject: any = standardData
            ? {
                label: standardData.subjectName,
                value: standardData.subjectId,
              }
            : undefined;

          const selectedDomain: any = standardData
            ? {
                label: standardData.domainName,
                value: standardData.domainId,
              }
            : undefined;

          bindContentAreas(selectedContent);
          bindSubjects(0, selectedSubject);
          bindDomains(0, selectedDomain);
        });
      });
    } else {
      bindContentAreas();
      if (parameters?.autoFillData) {
        bindSubjects(parameters?.autoFillData?.contentId);
        bindDomains(parameters?.autoFillData?.subjectId);
      }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const activeTabFromUrl: any = urlParams.get("activeTab");

    if (activeTabFromUrl === "AssociatedQuestions") {
      setActiveTab("AssociatedQuestions");
    } else if (activeTabFromUrl === "Worksheets") {
      setActiveTab("Worksheets");
    } else if (activeTabFromUrl === "Videos") {
      setActiveTab("Videos");
    } else if (activeTabFromUrl === "Slides") {
      setActiveTab("Slides");
    } else {
      setActiveTab("LinkedStandard");
    }
  }, [idToEdit]);

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Standard", url: Constant.STANDARDS },
      {
        name: idToEdit ? "Edit Standard" : "Add Standard",
        url: "",
      },
    ];

    if (id) {
      items.push({
        name: "",
        url: "",
        objectId: String(idToEdit),
      });
    }

    return items;
  };

  const toggleLang = () => {
    if (lang === 1) {
      setLang(2);
    } else {
      setLang(1);
    }
  };

  const handleUploadIcon = async (e) => {
    setStandardIcon(e.target.files[0]);
  };

  function handleIsHideFromStudentPractice(e: any) {
    setIsHideFromStudentPractice(e.target.checked);
  }
  function handleIsTestedStandard(e: any) {
    setIsTestedStandard(e.target.checked);
  }

  function handleRedirection(name: string, id: number) {
    if (name === "subject" && id) {
      navigate(Constant.SUBJECTDETAIL.replace(":id", id.toString()), {
        state: { subjectType: 1 },
      });
    } else if (name && id) {
      navigate(`/${name}/edit/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }

  const handleAddStandardGroup = () => {
    const standardGroupProps: any = {
      subjectId: standardData?.subjectId,
      domainId: standardData?.domainId,
      standardId: standardData?.standardId,
      existingStandardGroups: standardData?.standardGroups,
    };
    setStandardGroupInfo(standardGroupProps);
    setShowConfirmation(true);
  };

  return (
    <AllowedTo
      perform={[Permissions.standard_create, Permissions.standard_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {idToEdit ? "Edit Standard " : "Add Standard "}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <div className="mt-6 w-full">
              <div className="flex space-x-8">
                <div className="w-1/4 border rounded-lg shadow">
                  <form onSubmit={handleSubmit(submitHandler)}>
                    <div className="py-6 px-4">
                      <div
                        className={`flex ${
                          idToEdit ? "justify-between" : "justify-end"
                        }`}
                      >
                        {idToEdit && (
                          <a
                            className="cursor-pointer text-indigo-600"
                            onClick={() => handleAddStandardGroup()}
                          >
                            Add to standard group
                          </a>
                        )}
                        <div
                          className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4"
                          onClick={() => toggleLang()}
                        >
                          <span
                            className={`${
                              lang === 1
                                ? "bg-primary-color text-white"
                                : "bg-white text-gray-400"
                            } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                          >
                            English
                          </span>
                          <span
                            className={`${
                              lang === 2
                                ? "bg-primary-color text-white"
                                : "bg-white text-gray-400"
                            } w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                          >
                            Spanish
                          </span>
                        </div>
                      </div>

                      <div>
                        <div className="flex flex-row items-center mt-4 mb-4">
                          <div className="flex flex-row items-center mr-2">
                            <div>
                              <input
                                id="isHideFromStudentPractice"
                                type="checkbox"
                                checked={isHideFromStudentPractice}
                                onChange={handleIsHideFromStudentPractice}
                                className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                              />
                            </div>
                            <div className=" text-sm ">
                              <label className="font-medium text-gray-700">
                                Hide from student practice
                              </label>
                            </div>
                          </div>
                          <div className="flex flex-row items-center">
                            <div>
                              <input
                                id="isTestedStandard"
                                type="checkbox"
                                checked={isTestedStandard}
                                onChange={handleIsTestedStandard}
                                className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                              />
                            </div>
                            <div className=" text-sm ">
                              <label className="font-medium text-gray-700">
                                Tested Standard
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-1">
                          <div className="text-sm col-span-1 flex items-center ">
                            <label className="font-medium text-gray-700">
                              Name
                            </label>
                          </div>
                          <div>
                            <input
                              id="name"
                              value={standardName}
                              type="text"
                              autoComplete="off"
                              className={`${
                                lang === 1 ? "" : "hidden"
                              } mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                              onChange={(e) => {
                                setStandardName(e.target.value);
                              }}
                            />

                            <input
                              id="spanishName"
                              defaultValue={standardData?.spanishName}
                              type="text"
                              autoComplete="off"
                              className={`${
                                lang === 2 ? "" : "hidden"
                              } mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                              {...register("spanishName")}
                            />

                            {!isValid && standardName === "" && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Name is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            <label className="font-medium text-gray-700">
                              Code
                            </label>
                          </div>
                          <div>
                            <input
                              id="code"
                              value={code}
                              autoComplete="off"
                              type="text"
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              onChange={(e) => {
                                setCode(e.target.value);
                              }}
                            />

                            {!isValid && code === "" && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Code is required
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            {selectedContent?.value !== "0" ? (
                              <a
                                className="text-gray-700 text-sm underline"
                                onClick={() =>
                                  handleRedirection(
                                    "content-areas",
                                    parseInt(selectedContent?.value)
                                  )
                                }
                                href={`/content-areas/edit/${parseInt(
                                  selectedContent?.value
                                )}`}
                              >
                                Content Area
                              </a>
                            ) : (
                              <button className="text-gray-700 text-sm cursor-default">
                                Content Area
                              </button>
                            )}
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedContent}
                              onChange={handleContentAreaChange}
                              options={contentAreas}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            <a
                              className="text-gray-700 text-sm underline"
                              onClick={() =>
                                handleRedirection(
                                  "subject",
                                  parseInt(selectedSubject?.value)
                                )
                              }
                              href={Constant.SUBJECTDETAIL.replace(
                                ":id",
                                selectedSubject?.value.toString()
                              )}
                            >
                              Subject
                            </a>
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedSubject}
                              onChange={handleSubjectChange}
                              options={subjects}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1flex items-center ">
                            <a
                              className="text-gray-700 text-sm underline"
                              onClick={() =>
                                handleRedirection(
                                  "domains",
                                  parseInt(selectedDomain?.value)
                                )
                              }
                              href={`/domains/edit/${parseInt(
                                selectedDomain?.value
                              )}`}
                            >
                              Domain
                            </a>
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedDomain}
                              onChange={handleDomainChange}
                              options={domains}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center col-span-1">
                            <label className="font-medium text-gray-700">
                              {" "}
                              Load Order
                            </label>
                          </div>
                          <div>
                            <input
                              id="loadOrder"
                              name="loadOrder"
                              value={loadOrder}
                              autoComplete="off"
                              maxLength={2}
                              type="text"
                              onChange={handleLoadOrderChange}
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center col-span-1">
                            <label className="font-medium text-gray-700">
                              {" "}
                              Description
                            </label>
                          </div>
                          <div>
                            <textarea
                              style={{ minHeight: "150px" }}
                              id="desciption"
                              name="desciption"
                              autoComplete="off"
                              value={description}
                              onChange={handleDesciptionChange}
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center col-span-1">
                            <label className="font-medium text-gray-700">
                              {" "}
                              Notes
                            </label>
                          </div>
                          <div>
                            <textarea
                              style={{ minHeight: "150px" }}
                              id="notes"
                              name="notes"
                              autoComplete="off"
                              value={notes}
                              onChange={handleNotesChange}
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm flex items-center">
                            <label className="font-medium text-gray-700">
                              Upload Icon
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              type="hidden"
                              {...register("standardIcon", {
                                value:
                                  standardData && standardData.standardIcon,
                              })}
                            ></input>
                            <input
                              type="file"
                              id="icon"
                              name="icon"
                              onChange={handleUploadIcon}
                              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              defaultValue={standardIcon}
                            />
                            {standardData?.standardIcon && (
                              <img
                                title={props.title}
                                className="icon ml-2 h-10"
                                src={standardData?.standardIcon}
                                alt="Image not found"
                              />
                            )}
                          </div>
                        </div>

                        <div className="flex justify-end mt-8 items-center border-t ">
                          <button
                            type="submit"
                            className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                          >
                            {standardData ? "Update " : "Save"}
                          </button>
                          <Link to={Constant.STANDARDS} className="ml-2">
                            <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                              Cancel
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="w-3/4">
                  {standardData && standardData.standardId && (
                    <Fragment>
                      <div className="flex items-center justify-between bg-gray-100 w-full">
                        <div className="flex">
                          <button
                            onClick={() => setActiveTab("LinkedStandard")}
                          >
                            <h2
                              className={
                                activeTab === "LinkedStandard"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Linked Standard
                            </h2>
                          </button>
                          <button
                            onClick={() => setActiveTab("AssociatedQuestions")}
                          >
                            <h2
                              className={
                                activeTab === "AssociatedQuestions"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Associated Questions
                            </h2>
                          </button>
                          <button onClick={() => setActiveTab("Worksheets")}>
                            <h2
                              className={
                                activeTab === "Worksheets"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Worksheets
                            </h2>
                          </button>
                          <button onClick={() => setActiveTab("Videos")}>
                            <h2
                              className={
                                activeTab === "Videos"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Videos
                            </h2>
                          </button>
                          <button onClick={() => setActiveTab("Slides")}>
                            <h2
                              className={
                                activeTab === "Slides"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Slides
                            </h2>
                          </button>
                        </div>
                      </div>
                      {activeTab === "LinkedStandard" && (
                        <LinkedStandard
                          standardId={standardData.standardId}
                          standardData={standardData}
                        />
                      )}

                      {activeTab === "AssociatedQuestions" && (
                        <AssociatedQuestion
                          standardId={standardData.standardId}
                          standardData={standardData}
                        />
                      )}
                      {activeTab === "Worksheets" && (
                        <Worksheet
                          standardId={standardData.standardId}
                          standardData={standardData}
                        />
                      )}
                      {activeTab === "Videos" && (
                        <Videos
                          standard={standardVideoData}
                          languageId={lang}
                        />
                      )}
                      {activeTab === "Slides" && (
                        <Slide
                          standardId={standardData.standardId}
                          standardData={standardData}
                        />
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
              {showConfirmation && (
                <AddStandardGroup
                  {...standardGroupInfo}
                  title={"Add Standard Group"}
                  confirmAction={setShowConfirmation}
                  buttonText={"Add"}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
}

export default ManageStandard;
